import { TextField, ImageField } from '@sitecore-jss/sitecore-jss-nextjs';

export type EventListingResponse = {
  id: string;
  name: TextField;
  image: { jsonValue: ImageField };
  type: {
    targetItem: {
      id: string;
      eventType: TextField;
    };
  };
  inPersonEventLocation: {
    targetItem: {
      locationName: TextField;
    };
  };
  locationType: {
    targetItems: {
      id: string;
      name: string;
    }[];
  };
  children: {
    EventOccurrences: EventOccurrence[];
  };
};

export type EventOccurrence = {
  id: string;
  evolveEventID?: {
    value: string;
  };
  startDateTime: {
    jsonValue: {
      value: string;
    };
  };
  endDateTime: {
    jsonValue: {
      value: string;
    };
  };
  canceled: {
    boolValue: boolean;
  };
};
